import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import EcommerceImage from "../assets/img/productimages/Ecommerce.svg";
import HealthImage from "../assets/img/productimages/Health.svg";
import CMSImage from "../assets/img/productimages/CMSImage2.svg";
import TransportationImage from "../assets/img/productimages/Transportation1.svg";
import RetailImage from "../assets/img/productimages/Retail.svg";

const ProductItem = () => {
  return (
    <div>
      <Container className="main-section-item-product">
        <Row>
          <Col>
            <img src={EcommerceImage} alt="Ecommerce" />
          </Col>
          <Col md="auto"></Col>
          <Col xs md="5" lg="5">
            <div>
              <h1>Ecommerce</h1>
              <p>
                Build the most advanced Ecommerce platform to take your business
                to a new height. As we offer you a tailored eCommerce solution,
                you would be driving innovation. Curigma is the industry’s
                leading name in offering complete eCommerce development
                solutions to clients worldwide.
              </p>
              <br />
              <p>
                <b>
                  We deliver your eCommerce solutions for mobile and web
                  platforms that target B2B, B2C, C2B, C2C, and D2C. Our
                  services include:
                </b>
                <p></p>
                <li>100% Customizable eCommerce application </li>
                <li>ECommerce Module development </li>
                <li>Unified services delivery</li>
                <li>Multi-vendor eCommerce Solutions</li>
                <li>Payment Gateway Integration Services </li>
                <li>Custom Market Place Solutions</li>
              </p>
            </div>
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section-item-product">
        <Row>
          <Col>
            <img src={HealthImage} alt="Health care" />
          </Col>
          <Col md="auto"></Col>
          <Col xs lg="5">
            <div>
              <h1>Health Care</h1>
              <p>
                Focus on treating your patients as we bring you advanced
                healthcare tools that will automate all the workflow in your
                healthcare institution. We have skilled professionals who are
                driven by innovation. So, they bring you advanced healthcare
                apps to automate your business and offer you seamless customer
                service.
              </p>
            </div>
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section-item-product">
        <Row>
          <Col>
            <img src={CMSImage} alt="publishing" />
          </Col>
          <Col md="auto"></Col>
          <Col xs lg="5">
            <div>
              <h1>Publishing</h1>
              <p>
                With the world’s best content management team, Curigma delights
                you by offering tailored CMS. We possess our own Content
                management system to deliver the highest standards of
                professionalism. We provide customizable publishing services
                that aim to meet the client’s satisfaction.
              </p>
              <br />
              <p>
                <b>Our Publishing services include:</b>
                <p></p>
                <li>Cross-Media Publishing </li>
                <li>PDF and XML Workflow </li>
                <li>Audience Management</li>
              </p>
            </div>
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section-item-product">
        <Row>
          <Col>
            <img src={TransportationImage} alt="Transportation" />
          </Col>
          <Col md="auto"></Col>
          <Col xs lg="5">
            <div>
              <h1>Transportation</h1>
              <p>
                As we always say, it’s time for you to focus on customer
                service! Curigma brings you an advanced solution to automate
                workflow in transportation, logistics, trucking, and the
                mover/storage industries. We build a super-efficient application
                that will eliminate the need for humans in the transportation
                industry.
              </p>
              <br />
              <p>
                <b>Our ever-growing services include:</b>
                <p></p>
                <li>Dispatching systems </li>
                <li>Fleet management</li>
                <li>GPS/Field tracking systems </li>
                <li>POD signature capture </li>
                <li>Rate planning and comparison systems </li>
                <li>Barcode, Auto-ID, and RFID </li>
                <li>B2B, B2G data interfaces</li>
                <li>Route optimization systems</li>
              </p>
            </div>
          </Col>
        </Row>
        <hr />
      </Container>
      <Container className="main-section-item-product">
        <Row>
          <Col>
            <img src={RetailImage} alt="Retail" />
          </Col>
          <Col md="auto"></Col>
          <Col xs lg="5">
            <div>
              <h1>Retail</h1>
              <p>
                We believe every business must adapt itself as per the
                fast-changing dynamics of the Industry. And that’s where we come
                in to lead you. We develop customer-specific solutions that sets
                trend for the retail industry. Our easy–to–use products are
                scalable, flexible, and affordable.
              </p>
              <p>
                <b>Our wide array of products includes:</b>
                <p></p>
                <li>Inventory Management </li>
                <li>Product Management </li>
                <li>Supply Chain </li>
                <li>Point-of-Sale solutions </li>
                <li>eCommerce integration </li>
                <li>CRM</li>
              </p>
            </div>
          </Col>
        </Row>
        <hr />
      </Container>
    </div>
  );
};
export default ProductItem;
